import { cssVar } from '@fabric-app/ui/theme/variables';
import styled from 'styled-components';

export const Thumb = styled.div`
  background: ${cssVar['color-sidebar-resize-thumb']};

  height: 49px;
  width: 5px;
  border-radius: 2px;
  opacity: 0.5;
  transition:
    opacity 200ms,
    height 200ms;
`;

export const DragResizeHandle = {
  Thumb,
};
